module.exports = __webpack_public_path__ + "static/media/mavRav.4ca9b900.svg";